import donationHelperApi, {
  DonationProgress,
} from '@src/services/donationHelper';
import { useCallback, useEffect, useState } from 'react';

/**
 * 헌혈요청 상세의 모집 현황/참여자("돕겠습니다").
 * 백엔드 미배포 환경에서도 화면이 깨지지 않도록 실패 시 조용히 빈 상태로 둔다.
 */
export const useDonationHelpers = (donationUuid?: string) => {
  const [progress, setProgress] = useState<DonationProgress | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const load = useCallback(async () => {
    if (!donationUuid) return;
    try {
      setProgress(await donationHelperApi.getProgress(donationUuid));
    } catch (e) {
      // 백엔드에 아직 참여자 API가 없으면 섹션을 숨기기 위해 null 유지
      setProgress(null);
    } finally {
      setIsLoading(false);
    }
  }, [donationUuid]);

  useEffect(() => {
    load();
  }, [load]);

  const toggleHelp = useCallback(async () => {
    if (!donationUuid || isSubmitting) return false;
    setIsSubmitting(true);
    try {
      const next = progress?.iAmHelping
        ? await donationHelperApi.cancel(donationUuid)
        : await donationHelperApi.help(donationUuid);
      setProgress(next);
      return true;
    } catch (e) {
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, [donationUuid, progress, isSubmitting]);

  return { progress, isLoading, isSubmitting, toggleHelp, reload: load };
};

export default useDonationHelpers;
